<template>
    <div class="weather">
        <a href="https://www.accuweather.com/en/si/kojsko/297375/weather-forecast/297375" class="aw-widget-legal"></a><div id="awcc1527849160184" class="aw-widget-current"  data-locationkey="297375" data-unit="c" :data-language="language" data-useip="false" data-uid="awcc1527849160184" data-targeturl="http://za-te.net/vreme"></div>
    </div>
</template>

<script>
export default {
    name: 'app-weather',
    props: ['title', 'language'],

    data() {

        return {
            //
        };
    },

    methods: {
        getLanguage() {
            return this.language;
        }
    },

    mounted() {
        // current instance
        // console.log('this is current weather', this.title, this.language)
        let appWeather = document.createElement('script');
        appWeather.setAttribute('src', 'https://oap.accuweather.com/launch.js');
        // document.getElementById('weather').appendChild(appWeather);
        document.head.appendChild(appWeather);
    }

}

</script>
<style>
.weather {
    max-width: 500px;
    margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/elements/weather/Weather.vue